import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NaverCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = new URLSearchParams(window.location.search).get('code');
        console.log('Received Naver code:', code);  // 디버깅용 로그

        if (!code) {
          console.error('No code received from Naver');
          navigate('/');
          return;
        }

        if (window.opener) {
          // 팝업 창에서 부모 창의 콜백 함수 호출
          if (window.opener.naverLoginCallback) {
            try {
              await window.opener.naverLoginCallback(code);
              console.log('Naver login callback completed successfully');
            } catch (error) {
              console.error('Error in naverLoginCallback:', error);
            } finally {
              window.close();
            }
          } else {
            console.error('naverLoginCallback not found in opener');
            window.close();
          }
        } else {
          console.error('No opener window found');
          navigate('/');
        }
      } catch (error) {
        console.error('Error in Naver callback:', error);
        if (window.opener) {
          window.close();
        } else {
          navigate('/');
        }
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography>네이버 로그인 처리 중...</Typography>
    </Box>
  );
};

export default NaverCallback; 